export const GET_BILLING_INFO_PATH = 'api/landlord/billing/current';
